<template>
  <div>
    <Layout :containers="containers">
      <template v-slot:header>
        <HomeHeroBar
          :section="'home5'"
          @gradientButtonClicked="scrollToCGTCalculator"
        />
      </template>
      <template v-slot:intro>
        <div class="section-padding">
          <TitleRow
            :html="true"
            :title="`<p style='
          font-weight: 300;
          font-size: 28px;
          line-height: 34px;
          letter-spacing: -0.25%;
          text-align: center;
          color:#282828;
       '>
       Capital Gains Tax (CGT) Calculator
       </p>`"
            :description="`<p style='
        font-weight: 400;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0%;
        text-align: center;
        color:#1E1E1E;
       '>
        CGT is a tax you pay on the profit from selling property or investments. 
        <span style='
        font-weight: 600;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0%;
        text-align: center;
        color:#1E1E1E;
        '>
        CGT also applies when you pass away.</span>
        In this case SARS treats your assets as if you’d sold them, 
        <span style='
        font-weight: 600;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0%;
        text-align: center;
        color:#1E1E1E;
        '>
        which can significantly reduce what your loved ones inherit.</span>
       </p>
       <p style='
        font-weight: 400;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0%;
        text-align: center;
        color:#1E1E1E;
       '>Complete the details below to calculate your CGT.</p>`"
          />
        </div>
      </template>
      <template v-slot:capital-gains-calculator>
        <div ref="CGTCalculator">
          <CapitalTaxGainsCalculator
            :customLandingPage="true"
            @scrollToOtherCosts="scrollToOtherCosts"
          />
        </div>
      </template>
      <template v-slot:info-title-row>
        <!-- <div class="section-padding">
          <TitleRow
            :html="true"
            :title="`<p style='
                font-weight: 500;
                font-size: 28px;
                line-height: 32px;
                letter-spacing: -0.23px;
                text-align: center;
                color:#282828;
                    '>
                    The other costs <span style='font-weight: 300;'>your estate could face</span>, and how to avoid them
                    </p>`"
            :description="''"
          />
        </div> -->
        <div class="section-padding" ref="otherCosts">
          <InfoTilesContainer
            :tiles="infoTiles"
            @gradientButtonClicked="createYourWill"
            :buttonText="'CREATE MY WILL NOW'"
            :alternativeTitle="`<p style='
                font-weight: 500;
                font-size: 28px;
                line-height: 32px;
                letter-spacing: -0.23px;
                text-align: center;
                color:#282828;
                    '>
                    The other costs <span style='font-weight: 300;'>your estate could face</span>, and how to avoid them
                    </p>
                        <p style='
              margin:48px 0 35px 0;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              color:#747474;
              '>
             When you pass away, CGT is just one of the costs and taxes affecting your estate. Others include:</p>`"
            :additionalText="`  <p style='
              margin:48px 0 35px 0;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              color:#747474;
              '>An estate plan, documented in a legally valid will, can help reduce these costs and preserve more for your loved ones.</p>`"
          />
        </div>
      </template>
      <template v-slot:why-choose-us>
        <div class="section-padding">
          <ImageTextBanner
            :imageUrl="whitelabel.images.home4ReduceCostsImage"
            :title="`<p style='
              font-weight: 500;
              font-size: 28px;
              line-height: 34px;
              letter-spacing: -0.25%;
              color:#282828;
            '>Why not having a will places your loved ones at risk`"
            :paragraphOne="`<p style='
                font-weight: 600;
                font-size: 16px;
                line-height: 28px;
                letter-spacing: 0%;
                color:#282828;
                '>
               Without a will:
               </p>
            <ul class='list-disc'
            style='line-height: 28px;'
            >
       <li>The law decides who inherits.</li>
       <li>Your family could face delays and disputes.</li>
       <li>Estate duty, executor’s fees, and CGT can quickly shrink your estate — even force the sale of property.</li>
            </ul>
            <p style='
            margin-top:24px;
            font-weight: 300;
            font-size: 16px;
            line-height: 28px;
            letter-spacing: 0%;
            color:#282828;
            '>
           A will makes your wishes clear and helps protect your loved ones from unnecessary costs and stress.
            </p>
`"
            :reversed="true"
            :buttonText="'CREATE MY WILL NOW'"
            @gradientButtonClicked="createYourWill"
            :bottomMargin="true"
          />
        </div>
      </template>
      <template v-slot:create-your-will-info>
        <div class="section-padding">
          <InfoTilesContainer
            :tiles="infoTilesCreateYourWill"
            :buttonText="'CREATE MY FREE WILL'"
            @gradientButtonClicked="createYourWill"
            :alternativeTitle="`<p style='
              font-weight: 500;
              font-size: 28px;
              line-height: 32px;
              letter-spacing: -0.23px;
              text-align: center;
            '>
            How to create a will with Old Mutual
            </p>`"
            :additionalText="`
            <p style='
            font-weight: 400;
            font-style: Regular;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            color:#747474;
            '>
            When you create your will, <span
            style='font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            '>
          you also get access to EstateAssist</span> — personalised
            insurance cover that <span style='
            font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            '>shields your loved ones from costly estate 
            fees and taxes including Capital Gains Tax.</span>
            </p>
            `"
          />
        </div>
      </template>
      <template v-slot:create-your-will-banner>
        <div class="section-padding">
          <CreateYourWillBanner
            :alternativeBanner="true"
            :bannerText="`<p style='
              font-weight: 600;
              font-size: 28px;
              line-height: 36px;
              text-align: center;
            '>Join 23,000+ South Africans 
            <span style='
              font-weight: 300;
              font-size: 28px;
              line-height: 36px;
              text-align: center;
            '>who’ve created their wills online with Old Mutual since 2023</span>
            </p>`"
            :pb0="true"
          />
        </div>
      </template>
      <template v-slot:take-control>
        <div class="section-padding">
          <ImageTextBanner
            :imageUrl="whitelabel.images.home1JoinUsImage"
            :title="`<p style='
                font-weight: 600;
                font-size: 28px;
                line-height: 36px;
                color:#282828;
                '>
              You’ve seen what Capital Gains Tax could cost your estate.
                </p>`"
            :paragraphOne="`
            <p style='
            font-weight: 300;
            font-size: 28px;
            line-height: 36px;
              color:#282828;
            '>
          Protect your loved ones from unnecessary financial stress — create your will with Old Mutual.
            </p>`"
            :reversed="true"
            :buttonText="'CREATE MY WILL'"
            @gradientButtonClicked="createYourWill"
            :bottomMargin="true"
          />
        </div>
      </template>
      <template v-slot:callusback>
        <EstateAdministrationCostCalculatorFooter
          @requestACall="requestACall"
          v-if="whitelabel.brand !== 'quickwill'"
        />
      </template>
    </Layout>
    <SuccessSnackbar v-model="showAlert" :message="alertMessage" />
    <RequestACallDialog
      :showRequestACallDialog.sync="showRequestACallDialog"
      @success="showSuccessMessage"
    />
  </div>
</template>

<script>
  import HomeHeroBar from './HomeHeroBar.vue';
  import ButtonTilesContainer from '../ButtonTilesContainer.vue';
  import InfoTilesContainer from '../InfoTilesContainer.vue';
  import CreateYourWillBanner from '../CreateYourWillBanner.vue';
  import ImageTextBanner from '../ImageTextBanner.vue';
  import TestimonialsSection from '../TestimonialsSection.vue';
  import HR from '../../common/HR.vue';
  import Layout from '../../common/layouts/Layout.vue';
  import DynamicNavDrawer from '../../guest/DynamicNavDrawer.vue';
  import DrawerSignUp from '../../guest/DrawerSignUp.vue';
  import DrawerSignIn from '../../guest/DrawerSignIn.vue';
  import SuccessSnackbar from '../../common/SuccessSnackbar.vue';
  import EstateAdministrationCostCalculatorFooter from '../EstateCostCalculator/EstateAdministrationCostCalculatorFooter.vue';
  import RequestACallDialog from '../dialogs/RequestACallDialog.vue';
  import Accordion from '../../common/Accordion.vue';
  import TitleRow from '../../common/TitleRow.vue';
  import CapitalTaxGainsCalculator from '../calculators/capital_gains_tax/CapitalTaxGainsCalculator.vue';

  export default {
    name: 'Home5',
    metaInfo() {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.whitelabel.canonicalUrls.homepage,
          },
        ],
      };
    },
    props: {
      openSignupDrawerImmediately: {
        required: false,
        default: false,
        type: Boolean,
      },
      isReferralLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isActivationLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isPasswordResetLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      verifyUserLinkCode: {
        required: false,
        default: null,
        type: Object,
      },
    },
    components: {
      HomeHeroBar,
      ButtonTilesContainer,
      InfoTilesContainer,
      CreateYourWillBanner,
      ImageTextBanner,
      TestimonialsSection,
      DynamicNavDrawer,
      HR,
      Layout,
      DrawerSignUp,
      DrawerSignIn,
      SuccessSnackbar,
      EstateAdministrationCostCalculatorFooter,
      RequestACallDialog,
      Accordion,
      TitleRow,
      CapitalTaxGainsCalculator,
    },
    data(props) {
      return {
        signUpDrawerOpen: props.openSignupDrawerImmediately,
        signInDrawerOpen: false,
        showAlert: false,
        alertMessage: null,
        countryPattern: require('@/assets/shared/redesign/backgrounds/country-pattern.svg'),
        greenAccentOne: require('@/assets/shared/redesign/backgrounds/green-accent-1.svg'),
        greenAccentTwo: require('@/assets/shared/redesign/backgrounds/green-accent-2.svg'),
        purpleAccent: require('@/assets/shared/redesign/backgrounds/purple-accent.svg'),
        tribalPattern: require(`@/assets/old_mutual/homepage/generic.svg`),
        showRequestACallDialog: false,
      };
    },
    mounted() {
      if (localStorage.getItem('isLandingSimple')) {
        localStorage.removeItem('isLandingSimple');
        location.reload();
      }
    },
    methods: {
      scrollToOtherCosts() {
        const target = this.$refs.otherCosts;
        if (!target) return;
        const y = target.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: y, behavior: 'smooth' });
      },
      successResetPassword() {
        this.signInDrawerOpen = false;
        this.alertMessage =
          this.whitelabel.authentication.resetPassword.successMessage;
        this.showAlert = true;
      },
      loginClicked() {
        this.signUpDrawerOpen = false;
        this.signInDrawerOpen = true;
      },
      calculateCostsClicked() {
        this.$router.push('/estate-administration-cost-calculator');
      },
      drawerClosed() {
        this.signUpDrawerOpen = false;
      },
      signInDrawerClosed() {
        this.signInDrawerOpen = false;
      },
      quickStartCardLinkClicked(routeName) {
        if (routeName === 'SignUpPage') {
          this.signUpDrawerOpen = true;
        } else {
          this.$router.push({ name: routeName });
        }
      },
      createYourWill() {
        this.$router.push('/register');
      },
      estateCostCalculator() {
        this.$router.push({
          name: 'EstateAdministrationCostCalculator',
        });
      },
      requestACall() {
        this.showRequestACallDialog = true;
      },
      showSuccessMessage(success) {
        this.$emit('success', success);
      },
      scrollToCGTCalculator() {
        if (this.$refs.CGTCalculator) {
          this.$refs.CGTCalculator.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      },
    },
    computed: {
      containers() {
        return [
          {
            name: 'header',
            background: 'countryPattern',
            class: 'hero-banner',
          },
          {
            name: 'intro',
            fadedRow: true,
            background: 'countryPattern',
          },
          {
            name: 'capital-gains-calculator',
            hr: true,
          },
          {
            name: 'info-title-row',
          },
          {
            name: 'why-choose-us',
            hr: true,
          },
          {
            name: 'create-your-will-info',
          },
          {
            name: 'create-your-will-banner',
          },
          {
            name: 'take-control',
          },
          {
            name: 'callusback',
          },
        ];
      },
      buttonTiles() {
        return [
          {
            imageUrl: this.whitelabel.images.home1ButtonTileOne,
            title: '',
            description: `Answer a few guided questions`,
          },
          {
            imageUrl: this.whitelabel.images.home1ButtonTileTwo,
            title: '',
            description: `Review your personalised will`,
          },
          {
            imageUrl: this.whitelabel.images.home1ButtonTileThree,
            title: '',
            description: `Print, sign and validate`,
          },
        ];
      },
      infoTiles() {
        return [
          {
            imageUrl: this.whitelabel.images.home4InfoTitleOne,
            title: `Estate duty`,
            description: `A tax of up to 25% levied on estates valued above R3.5 million.`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleTwo,
            title: `Executor's fees`,
            description: `A fee of up to 3.5% of your estate value. Applied on estates valued above R250 000+.`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleThree,
            title: `Conveyancing & admin costs`,
            description: `Legal and transfer fees for property and other assets.`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleFour,
            title: `Trust setup costs`,
            description: `Applicable if you're protecting assets for children or dependants.`,
          },
        ];
      },
      infoTilesCreateYourWill() {
        return [
          {
            imageUrl: this.whitelabel.images.home4InfoTitleSix,
            title: `Answer a few guided questions`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleFive,
            title: `Review your personalised will`,
          },
          {
            imageUrl: this.whitelabel.images.home4InfoTitleSeven,
            title: `Print, sign and validate`,
          },
        ];
      },
      accordionData() {
        return this.whitelabel.FAQs1;
      },
    },
  };
</script>
<style lang="scss" scoped>
  @media only screen and (min-width: 601px) and (max-width: 807px) {
    .mobile-padding-top {
      padding-top: 111px;
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 600px) {
    .mobile-padding-top {
      padding-top: 133px;
    }
  }
</style>
